export default __webpack_public_path__ + "static/media/3.479e6e85.jpg";